module.exports = __webpack_public_path__ + "static/img/anxun52.3eba1e07.png";